import todoListReducers from './TodoList/TodoList.reducers';

export default {
  ...todoListReducers,
};
